import { render, staticRenderFns } from "./SegCeseTable.vue?vue&type=template&id=6cd3fbab&scoped=true&"
import script from "./SegCeseTable.vue?vue&type=script&lang=js&"
export * from "./SegCeseTable.vue?vue&type=script&lang=js&"
import style0 from "./SegCeseTable.vue?vue&type=style&index=0&id=6cd3fbab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3fbab",
  null
  
)

export default component.exports